import React from 'react';

function PublicPage() {
    return (
        <div>
            <h5>Welcome to the public page!</h5>
        </div>
    );
}

export default PublicPage;
